/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioFamiliasCV from './controladorVista/formularioFamiliasCV';
import TablaFamiliasCV from './controladorVista/tablaFamiliasCV';
import { estadoIncial, reductor } from './reductorFamilias';

const Familias: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaFamiliasCV />
        <FormularioFamiliasCV />
    </ProveedorEstado>
);

export default Familias;
